import http from '../../../libs/http';
import * as types from './charge-activity-mutation-types';

/**
 * 获取充值赠送优惠券配置
 * @param {Boolean} noCache 是否使用缓存
 */
export const getChargeActivity = ({ commit, state }, noCache) => new Promise((resolve, reject) => {
  if (state.charge_activity && !noCache) {
    resolve(state.charge_activity);
  } else {
    http.post('/sys/recharge_activity')
      .then((data) => {
        commit(types.CHARGE_ACTIVITY, data);
        resolve(data);
      }).catch(() => {
        reject();
      });
  }
});



// WEBPACK FOOTER //
// ./src/store/modules/charge-activity/charge-activity-actions.js